module.exports = __webpack_public_path__ + "static/offices-content-image-22_new-79eaf7eeb367b8a73fd3d0399471f95e.jpg";